const RENAMED_MODS = new Map([['crossfire', 'quickfire'], ['rush', 'surge']]);

export default function currentModName(name) {
  const renamed = typeof name === 'string' && RENAMED_MODS.get(name.toLowerCase());
  if (!renamed) return name;
  return /^[A-Z]/.test(name) ? renamed.charAt(0).toUpperCase() + renamed.slice(1) : renamed;
}
